import { Button } from 'src/ui/common/atoms/button';
import { CardBox } from 'src/ui/common/layouts/card-box';
import styled, { css } from 'styled-components';

export const StyledLoadMore = styled(Button)`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 25px;
`;

export const StyledCardBox = styled(CardBox)<{ isActivities: boolean }>`
    ${({ isActivities }) =>
        isActivities &&
        css`
            position: relative;
            padding-bottom: 50px;
        `}
`;
